
/**
 * 
 * @export
 * @interface TextovaHodnotaSpec
 */
export interface TextovaHodnotaSpec {
    /**
     * 
     * @type {Array<string>}
     * @memberof TextovaHodnotaSpec
     */
    'povoleneHodnoty'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TextovaHodnotaSpec
     */
    'typHodnoty'?: TextovaHodnotaSpecTypHodnotyEnum;
}

export const TextovaHodnotaSpecTypHodnotyEnum = {
    PravdaNepravda: 'PRAVDA_NEPRAVDA',
    ZoznamHodnota: 'ZOZNAM_HODNOTA',
    TextovaHodnota: 'TEXTOVA_HODNOTA'
} as const;

export type TextovaHodnotaSpecTypHodnotyEnum = typeof TextovaHodnotaSpecTypHodnotyEnum[keyof typeof TextovaHodnotaSpecTypHodnotyEnum];


